import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ActionsAnalyticsService, CART_TYPES, IPaymentInfo, IUserPlan, MobileCustomPlansServiceNoSync,
  MobilePlanItem, PURCHASE_INTENT, UserAccountServiceNoSync } from '@ztarmobile/zwp-service-backend';
import { ToastrHelperService } from '../../../../services/toast-helper.service';
import { ACCOUNT_ROUTE_URLS, ROUTE_URLS, SHOP_ROUTE_URLS } from '../../../app.routes.names';
import { AppState } from '../../../app.service';
import { OrdersService } from '@ztarmobile/zwp-service-backend-v2';
import { UserDataService } from '@services/user-data.service';

@Component({
  selector: 'app-change-plan-summary',
  templateUrl: './change-plan-summary.component.html',
  styleUrls: ['./change-plan-summary.component.scss']
})
export class ChangePlanSummaryComponent implements OnInit, OnDestroy {

  @Input() selectedMobilePlan: MobilePlanItem;
  @Input() selectedUserPlan: IUserPlan;
  public planCategory: string;
  @Input() nextCycle;
  @Output() backToMain: EventEmitter<boolean> = new EventEmitter<boolean>();
  public changePlanId: string;
  public isCheckoutFlow = true;
  public isPromoApplicable = true;
  private alive = true;
  loadingPrice: boolean;

  constructor(private mobilePlansService: MobileCustomPlansServiceNoSync,
               private ordersService: OrdersService, private appState: AppState,
              private userAccountService: UserAccountServiceNoSync, private toastHelper: ToastrHelperService, private analyticsService: ActionsAnalyticsService,
              private router: Router, private userDataService: UserDataService) {
  }

  ngOnInit(): void {
    this.isCheckoutFlow = !this.nextCycle;
    if (!!this.selectedMobilePlan) {
      if (!!this.selectedMobilePlan?.subscriptionCycles && this.selectedMobilePlan?.subscriptionCycles === 3) {
        this.loadingPrice = true;
        this.userAccountService.checkApplicablePromotion(this.selectedUserPlan.mdn, this.selectedMobilePlan.id).then((result) => {
          this.isPromoApplicable = result.applicable;
          this.loadingPrice = false;
        }, (error) => {
          this.isPromoApplicable = false;
          this.loadingPrice = false;
        });
      }
    }
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

  public goToAccountSummary(): void {
    this.router.navigate([`${ACCOUNT_ROUTE_URLS.BASE}/${ACCOUNT_ROUTE_URLS.SUMMARY}`]);
  }

  public userConfirmed(): void{
    if (!!this.isCheckoutFlow) {
      this.setPlanIncart();
      const params = {};
      params[SHOP_ROUTE_URLS.PARAMS.CHANGE_NEXT_CYCLE] = this.nextCycle;
      params[ROUTE_URLS.PARAMS.USER_PLAN_ID] = this.selectedUserPlan.id;
      this.router.navigate([`${SHOP_ROUTE_URLS.BASE}/${SHOP_ROUTE_URLS.CART}`]);
    } else {
      this.setPlanIncart();
      this.applyChangePlanWithoutCheckout();
    }
  }

  public back(): void {
    this.backToMain.emit(true);
  }
  private setPlanIncart(): void {
    sessionStorage.removeItem('shippingAddress');
    sessionStorage.removeItem('shippingMethod');
    sessionStorage.removeItem('payment_id');
    sessionStorage.removeItem('auto_renew');
    sessionStorage.removeItem('useFromBalance');
    sessionStorage.removeItem('voucherUsed');
    sessionStorage.setItem('changeNextCycle', this.nextCycle);
    const price = !!this.isPromoApplicable ? this.selectedMobilePlan?.subscriptionCycles * this.selectedMobilePlan.promoMoPrice :
    this.selectedMobilePlan?.subscriptionCycles * this.selectedMobilePlan.price;
    this.analyticsService.trackAddToCartGA4(PURCHASE_INTENT.CHANGE, [this.selectedMobilePlan], price);
    this.mobilePlansService.setCartType(CART_TYPES.CHANGE_PLAN);
    this.mobilePlansService.setActivePlanId(this.selectedUserPlan?.id);
    this.mobilePlansService.setBasePlan(this.selectedMobilePlan);
  }
  private applyChangePlanWithoutCheckout(): void {
    this.appState.loading = true;
    const paymentInfo = {} as IPaymentInfo;
    paymentInfo.id = this.selectedUserPlan.paymentMethodId;
    this.ordersService.changePlan({
      nextCycle: true,
      newBasePlanId: this.selectedMobilePlan?.id,
      addOnRenewable: false,
      paymentMethod: null
    }).then(() => {
      this.appState.loading = false;
      this.toastHelper.showSuccess('Your plan change request has been submitted successfully, and will take effect on your next cycle');
      this.userDataService.callSyncApi(this.selectedUserPlan.id, this.selectedUserPlan.mdn);
      this.mobilePlansService.clearUserCart();
      this.goToAccountSummary();
    }, (error) => {
      this.appState.loading = false;
      this.mobilePlansService.clearUserCart();
      this.toastHelper.showAlert(error.error.errors[0].message);
    });
  }

}
